const REPLACEMENT_EXPERIENCE_NAMES: Record<string, string> = {
  UberPreOrder: 'Scheduled',
};

export const formatExperienceName = (experienceName?: string) => {
  if (!experienceName) return experienceName;
  return REPLACEMENT_EXPERIENCE_NAMES[experienceName] ?? experienceName;
};
